(function () {
  if (document.querySelector('.article-product-showcase') === null) return;

  document.querySelectorAll('.article-product-showcase').forEach(function (el) {
    var handles = (el.getAttribute('data-handles') || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    if (!handles.length) return;

    var title = el.getAttribute('data-title') || 'Nos pièces 12LUNES';

    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
    })).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) return;

      var cards = products.map(function (p) {
        var variant = p.variants[0];
        var price = (variant.price / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        var img = p.images[0] ? p.images[0].src : '';
        var available = variant.available;
        var badge = available ? '' : '<span class="apc-badge">Épuisé</span>';

        return '<a href="/products/' + p.handle + '" class="apc-card">'
          + (img ? '<div class="apc-img-wrap"><img src="' + img + '" alt="' + p.title + '" loading="lazy"></div>' : '')
          + '<div class="apc-info">'
          + badge
          + '<span class="apc-name">' + p.title + '</span>'
          + '<span class="apc-price">' + price + '&nbsp;€</span>'
          + '</div>'
          + '</a>';
      }).join('');

      el.innerHTML = '<div class="apc-wrap">'
        + '<p class="apc-heading">' + title + '</p>'
        + '<div class="apc-grid">' + cards + '</div>'
        + '</div>';
    });
  });
})();
